import {
  JsonapiEntity,
  attribute,
  entity,
} from '@talisdev/jsonapi-transformers';

@entity({ type: 'citation_styles' })
export class CitationStyle extends JsonapiEntity<CitationStyle> {
  @attribute() description: string;
  @attribute() is_default: boolean;
}
